import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuIndex: "studytasks",
    directionalCheckIsShow: false,
    accountType: "",
  },
  mutations: {
    changeMenuIndex(state, opt) {
      state.menuIndex = opt.currentMenuIndex;
    },
    changeDirectionalCheckIsShow(state, opt) {
      state.directionalCheckIsShow = opt.directionalCheckIsShow;
    },
    changeAccountType(state, opt) {
      state.accountType = opt.accountType;
    },
  },
  actions: {},
  modules: {},
});
